/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const carouselSlideSX: SxProps<Theme> = (theme) => ({
	'&.carousel__slide': {
		textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	'.carousel__inner-slide': {
		position: 'relative',
		maxWidth: '245px',
		[theme.breakpoints.down(600)]: {
			minWidth: '6.5em',
		},
		[theme.breakpoints.up(600)]: {
			minWidth: '10em',
		},
		// maxHeight: '330px',
		pb: '2px',
		display: 'flex',
		flexDirection: 'column',
		'.MuiCard-root': {
			flexGrow: 1,
		},
	},
});

export const cardNameSx:SxProps = {
    '& > a':{
		overflow: 'hidden',
		display:'-webkit-box',
		fontSize:15,
		mt:globalBreak({mobile:0,desktop:1}),
		WebkitBoxOrient:'vertical',
		WebkitLineClamp:2,
		fontWeight:'bold'
	}
}

export const cardImageSx:SxProps = {
    minHeight:globalBreak({mobile:'unset', desktop:'unset'})
}